import React from 'react';

import { Information } from '../Information';

export function InformationBoxCE() {
  return (
    <Information.Root>
      <Information.Title />
      <Information.Body />
    </Information.Root>
  );
}
